import React from 'react'
import { Routes } from '../config/routes'

import type { PublicRouteConfig } from '../types'
import { Login } from '../../main/containers/auth/Login/Login'
import { AuthCallback } from '../../main/containers/auth/AuthCallback/AuthCallback'

import { CheckEmailConfirmation } from '../../main/containers/auth/ForgotPassword/CheckEmailConfirmation'
import { RequestResetForm } from '../../main/containers/auth/ForgotPassword/RequestResetForm'
import { ResetPasswordForm } from '../../main/containers/auth/ForgotPassword/ResetPasswordForm'
import { NVLRoot } from '../../containers/NationalVendorList/NVLRoot'
import {
    RegisterRouter,
    UserRegister,
} from '../../main/containers/auth/Register'
import { PublicLayout } from '../layouts/PublicLayout'
import { DeleteAccount } from '../../main/containers/auth/DeleteAccount/DeleteAccount'
import { VendorQuestionnaire } from '../../main/containers/auth/Questionnaire'
import { UpdateVendorPricingForm } from '../../containers/Workforce/UpdateVendorPricingForm'
import { GuestCardFormPage } from '../../containers/Outbound/Campaign/GuestCards/GuestCardFormPage'
import { GuestCardLinkFormPage } from '../../containers/Outbound/WebTools/GuestCardLinkFormPage'
import { ApplicationGatePage } from '../../containers/ApplicationGate'
import { ScreeningMockPage } from '../../containers/ScreeningMock'
import { VendorCOIUploadPage } from '../../containers/VendorCOIUpload'
import { VendorW9UploadPage } from '../../containers/VendorW9Upload'
import { BidRFPPage } from '../../containers/RFP/BidRFPPage'
import { RfpMessagePage } from '../../containers/RFP/RfpMessagePage'

export const publicRoutes: PublicRouteConfig[] = [
    {
        path: Routes.public.authCallback,
        component: AuthCallback,
        layout: PublicLayout,
        exact: true,
    },
    {
        path: Routes.public.login,
        component: Login,
        layout: PublicLayout,
    },
    {
        path: Routes.public.requestPasswordReset,
        component: RequestResetForm,
        layout: PublicLayout,
    },
    {
        path: Routes.public.resetPassword,
        component: ResetPasswordForm,
        layout: PublicLayout,
    },
    {
        path: Routes.public.checkEmailConfirmation,
        component: CheckEmailConfirmation,
        layout: PublicLayout,
    },
    {
        path: Routes.public.register,
        component: RegisterRouter,
        layout: PublicLayout,
    },
    {
        path: Routes.public.deleteAccount,
        component: DeleteAccount,
        layout: PublicLayout,
    },
    {
        path: Routes.public.vendorRegister,
        component: VendorQuestionnaire,
        layout: PublicLayout,
    },
    {
        path: Routes.public.userRegister,
        component: UserRegister,
        layout: PublicLayout,
    },
    {
        path: Routes.public.vendorPricing,
        component: UpdateVendorPricingForm,
        layout: PublicLayout,
    },
    {
        path: Routes.public.guestCardLink,
        component: GuestCardLinkFormPage,
        layout: PublicLayout,
    },
    {
        path: Routes.public.guestCardForm,
        component: GuestCardFormPage,
        layout: PublicLayout,
    },
    {
        path: Routes.public.applicationGate,
        component: ApplicationGatePage,
        layout: PublicLayout,
    },
    {
        path: Routes.public.screeningMock,
        component: ScreeningMockPage,
        layout: PublicLayout,
    },
    {
        path: Routes.public.vendorCOIUpload,
        component: VendorCOIUploadPage,
        layout: PublicLayout,
    },
    {
        path: Routes.public.vendorW9Upload,
        component: VendorW9UploadPage,
        layout: PublicLayout,
    },
    {
        path: Routes.public.bidRFP,
        component: BidRFPPage,
        layout: PublicLayout,
        exact: true,
    },
    {
        path: Routes.public.rfpMessage,
        component: RfpMessagePage,
        layout: PublicLayout,
        exact: true,
    },
]
